export default __webpack_public_path__ + "static/media/846.611de3af.png";